import { render } from "./documentView.vue?vue&type=template&id=5738a3df"
import script from "./documentView.vue?vue&type=script&lang=js"
export * from "./documentView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__